const IS_PRODUCTION = false;
const networkList = {
  base_url: IS_PRODUCTION
    ? "https://qms.rainbowhospitals.in:3000/"
     :"http://13.234.109.18:3000/",
  //  :"http://localhost:3000/",
    websocket_url1: IS_PRODUCTION
    ? "https://qms.rainbowhospitals.in:3001/"
      :"http://13.234.109.18:3001/",
  // :"http://localhost:3000/",
  //   websocket_url2: IS_PRODUCTION
  //   ? "https://qms.rainbowhospitals.in:3000/"
  //  :"http://13.234.109.18:3001/",
  //  :"http://localhost:3001/",
    doctor_profile_url: IS_PRODUCTION
    ? "https://qms.rainbowhospitals.in:3000/uploads/doctor_images/"
      : "http://13.234.109.18:3000/uploads/doctor_images/"

   // :"http://localhost:3001/uploads/doctor_images/"
     ,
  login: "login",
  queue_workflow: "getProcessStages",
  master_unit: "getUnits",
  master_department: "getDepartments",
  master_serviceGroup: "getServices",
  master_excludeServices: "getQueueServiceNames",
  master_queueOperators: "getQueueOperatorsforDropdown",
  master_queueTechnicians: "getQueueTechnicianforDropdown",
  master_doctor: "getDoctors",
  master_operator: "getServiceOperators",
  create_queue: "createQueueConfig",
  queue_list: "getQueues",
  queue_config: "getQueueConfig",
  getMasterPages: "getMasterPages",
  checkDuplicateRole: "checkDuplicateRole",
  createNewRole: "createNewRole",
  getRolesList: "getRolesList",
  getAccessLevels: "getAccessLevels",
  checkDuplicateUser: "checkDuplicateUser",
  createUser: "createUser",
  getRolePermissions: "getRolePermissions",
  getUsersDropdown: "getUsersDropdown",
  checkDuplicateTvDisplay: "checkDuplicateTvDisplay",
  getTvDisplays: "getTvDisplays",
  getQueueListDropDown: "getQueueListDropDown",
  getChemists: "getChemists",
  getDispatchers: "getDispatchers",
  addTvDisplay: "addTvDisplay",
  tvDisplayLogin: "tvDisplayLogin",
  getTvCounter: "getTvCounter",
  getTatReport: "getTatReport",
  getPlebos: "getPlebos",
  getAnomalyReport: "getAnomalyReport",
  viewRolePermissions: "viewRolePermissions",
  getAppointmentSlots: "getAppointmentSlots",
  addAppointments: "addAppointments",
  disableAppointments: "disableAppointments",
  cancelAppointments: "cancelAppointments",
  createUnit: "createUnit",
  getDepartments: "getDepartments",
  createDepartment: "createDepartment",
  rescheduleAppointments: "rescheduleAppointments",
  getDepartmentsList: "getDepartmentsList",
  getServicesBasedOnUserId: "getServicesBasedOnUserId",
  CheckAppointmentToken: "checkAppointments",
  editUnit: "editUnit",
  editDepartment: "editDepartment",
  getServicesList: "getServicesList",
  editService: "editService",
  createService: "createService",
  getDoctorsList: "getDoctorsList",
  createDoctor: "createDoctor",
  updateDoctor: "updateDoctor",
  getMasterServicesList: "getMasterServicesList",
  createMasterService: "createMasterService",
  getMasterServices: "getMasterServices",
  checkPatientbill: "checkPatientbill",
  getQueueInfoById: "getQueueInfoById",
  getDisabledAppointmentSlots: "getDisabledAppointmentSlots",
  getAppointmentDoctorsById: "getAppointmentDoctorsById",
  getTvById: "getTvById",
  downloadTatReport: "downloadTatReport",
  updateTvDisplay: "updateTvDisplay",
  deleteDisabledAppointmentSlot: "deleteDisabledAppointmentSlot",
  getUserDetailsById: "getUserDetailsById",
  updateUserDetailsById: "updateUserDetailsById",
  deleteTvDisplay: "deleteTvDisplay",
  editQueueConfig: "editQueueConfig",
  getTvCounterWithNoAuth: "getTvCounterWithNoAuth",
  getAppointmentBookingReasons: "getAppointmentBookingReasons",
  getPatientDetailsForApptSlot: "getPatientDetailsForApptSlot",
  getRoomsForAppointmentSlotBlocking: "getRoomsForAppointmentSlotBlocking",
  getPatientTypes: "getPatientTypes",
  getBlockedSlots: "getBlockedSlots",
  addBlockSlot: "addBlockSlot",
  deleteBlockedSlot: "deleteBlockedSlot",
  noShowReport: "noShowReport",
  getProcessStages: "getProcessStages",
  getNamesBasedonServiceIdUnitId: "getNamesBasedonServiceIdUnitId",
  getServiceNames: "getServiceNames",
  getAppointmentRescheduleReasons: "getAppointmentRescheduleReasons",
  getAllDoctorsDisplays: "getAllDoctorsDisplays",
  addQueueDoctor: "addQueueDoctor",
  getQueueDoctorById: "getQueueDoctorById",
  getQueueListBasedonUnit: "getQueueListBasedonUnit",
  deleteQueueDoctor: "deleteQueueDoctor",
  updateQueueDoctor: "updateQueueDoctor",
  getExceptionReport: "getExceptionReport",
  getCumulativeDelaysReport: "getCumulativeDelaysReport",
  getallDoctorsforDropdown: "getallDoctorsforDropdown",
  getallOperatorsforDropdown: "getallOperatorsforDropdown",
  getallTechnicianforDropdown: "getallTechnicianforDropdown",
  getallDcAppointmentforDropdown: "getallDcAppointmentforDropdown",
  getQueueList: "getQueueList",
  queueStatusChange: "queueStatusChange",
  earliestAlgStatusChange: "earliestAlgStatusChange",
  getQueueDetails: "getQueueDetails",
  updateRole: "updateRole",
  getProfileDetails: "getProfileDetails",
  changeProfilePassword: "changeProfilePassword",
  updateQueueConfiguration: "updateQueueConfiguration",
  updateQueueUsers: "updateQueueUsers",
  getComplianceReport: "getComplianceReport",
  getComplianceReportExport: "getComplianceReportExport",
  updateMasterService: "updateMasterService",
  roomDurationPercentageChange: "roomDurationPercentageChange",
  addPayertypeAppointmentSlots: "addPayertypeAppointmentSlots",
  getPayertypeAppointmentSlots: "getPayertypeAppointmentSlots",
  deletePayertypeAppointmentSlot: "deletePayertypeAppointmentSlot",
  payertypeAlgStatusChange: "payertypeAlgStatusChange",
  getIndentWorklist: "getIndentWorklist",
  userStatusChange: "userStatusChange",
  generateTokenForQueue: "generateTokenForQueue",
  getTokensForTG: "getTokensForTG",
  getWorkStations: "getWorkStations",
  addWorkStation: "addWorkStation",
  changeWorkStationStatus: "changeWorkStationStatus",
  updateWorkStation: "updateWorkStation",
  BillerTokenList: "getBillerTokenList",
  AssignTokenToBiller: "startAssignTokenToBiller",
  BillerCheckOutPatient: "checkOutPatientforQueue",
  AssignNextTokenToBiller: "nextAssignTokenToBiller",
  getWorkStationsForDoctorORBillers: "getWorkStationsForDoctorORBillers",
  getVitalQueuePatients: "getVitalQueuePatients",
  getTVdisaplayTokenswithNoAuth: "getTVdisaplayTokenswithNoAuth",
  addNewPatientFromOperator: "addNewPatientFromOperator",
  getOPDTVScreensWithNoAuth: "getOPDTVScreensWithNoAuth",
  getOverallTatReportsByDepartment: "getOverallTatReportsByDepartment",
  getHourlyTatReportsByDepartment: "getHourlyTatReportsByDepartment",
  getOverallBillingTATReport: "getOverallBillingTATReport",
  getHourlyBillingTATReport: "getHourlyBillingTATReport",
  doctorsStatusSwitch: "changeStatusForDoctorList",
  getDoctorIdDetails: "getDoctorIdDetails",
  DashboardData: "getQueueStats",
  DashboardDetailsInfoByDepartment: "getDashboardDetailsInfoByDepartmentIds",
  DashboardDetailsInfoByBiller: "getDashboardDetailsInfoByBiller",
  getWorkStationDetails: "getWorkStationDetails",
  changeTvDisplayStatus: "changeTvDisplayStatus",
  changeStatusForDoctorList: "changeStatusForDoctorList",
  getUsersList:'getUsersList',
  getWorkStationsByUnit:'getWorkStationsByUnit',
  getMasterTvDisplays:'getMasterTvDisplays',
  storeDoctorBreakDetails:'storeDoctorBreakDetails',
  updateBreakStatusTime:'updateBreakStatusTime',
  getDoctorBreakReasons:'getDoctorBreakReasons',
  tv_base_url: IS_PRODUCTION
    ? "https://qms.rainbowhospitals.in:80/"
    : "http://13.234.109.18/",
   // : "http://localhost/",
};
export default networkList;